import { SECTION_IDS, type SectionId } from "@ravnar/api-contract";

/** The business domains the console is organized around; each owns a hue in src/styles.css. */
export { SECTION_IDS, SECTION_LABELS, type SectionId } from "@ravnar/api-contract";

/** Route of each section page. */
export const SECTION_PATHS = {
	finance: "/finance",
	legal: "/legal",
	people: "/people",
	equity: "/equity",
} as const satisfies Record<SectionId, string>;

/** Dot color per section. Full class names, never built from strings, so Tailwind can find them. */
export const SECTION_DOT_CLASS: Readonly<Record<SectionId, string>> = {
	finance: "bg-finance",
	legal: "bg-legal",
	people: "bg-people",
	equity: "bg-equity",
};

/**
 * The sections whose pages are still to come. The rail marks them "Soon" and Home's overview "Coming soon", neither
 * links to them, and Home counts none of their items; a notification about one opens on the Notifications page instead,
 * and their routes send whoever opens them Home. Taking a section out of this set opens its page again.
 */
export const COMING_SOON_SECTIONS: ReadonlySet<SectionId> = new Set<SectionId>(["legal", "equity"]);

/** Whether a path is the page of a section still to come: somewhere no link may lead. */
export function isComingSoonPath(path: string): boolean {
	return SECTION_IDS.some(id => COMING_SOON_SECTIONS.has(id) && SECTION_PATHS[id] === path);
}
